import { BuilderAnimationFrame } from './builderAnimationFrame';
export type BuilderAnimationType = 'sequence';

export type BuilderAnimationLoop = number;

export class BuilderAnimation {
    public type: BuilderAnimationType = 'sequence';

    /**
     * Null = no loop. 0 = forever. positive = limited number of loops.
     */
    public loop: BuilderAnimationLoop | null = 0;

    public frames: BuilderAnimationFrame[] = [];
}
